import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import { Subtitle2 } from 'components/Typography';
import SwipeListPanel from '../SwipeListPanel';
import { filterTypes } from '../SwipeListPanel';

import styles from './styles';

const EmptyFilterMessage = "There are no swipes that match your selected filter";

const EmptyStateMessage = (swipeRetention) => `You haven't swiped in or swiped out any cards in the past ${swipeRetention} hours`;

class SwipeList extends React.Component {

    state = { currentFilter: filterTypes.AllSwipeInOut };

    filterPanelRow = () => {
        const { currentFilter } = this.state;
        const classes = this.props.classes;

        const isAll = currentFilter === filterTypes.AllSwipeInOut;
        const isSwipeIn = currentFilter === filterTypes.SwipeIn;
        const isSwipeOut = currentFilter === filterTypes.SwipeOut;

        return (
            <React.Fragment>
                <Subtitle2 paragraph>
                    Swipe types filter
                </Subtitle2>
                <Grid container justifyContent="flex-start" alignItems="center" >
                    <Chip
                        onClick={() => this.setState({ currentFilter: filterTypes.AllSwipeInOut })}
                        className={classes.chip}
                        variant="outlined"
                        color={isAll ? 'primary' : 'default'}
                        label="All" />
                    <Chip
                        onClick={() => this.setState({ currentFilter: filterTypes.SwipeIn })}
                        className={classes.chip}
                        variant="outlined"
                        color={isSwipeIn ? 'primary' : 'default'}
                        label="In" />
                    <Chip
                        onClick={() => this.setState({ currentFilter: filterTypes.SwipeOut })}
                        className={classes.chip}
                        variant="outlined"
                        color={isSwipeOut ? 'primary' : 'default'}
                        label="Out" />
                </Grid>
            </React.Fragment>
        );
    };

    render() {
        return (
            <SwipeListPanel
                HeaderComponent={this.filterPanelRow}
                emptyStateMessage={EmptyStateMessage}
                emptyFilterMessage={EmptyFilterMessage}
                supervisorData={this.props.supervisorData}
                showEmptyFilterMessage={true}
                swipes={this.props.swipes}
                config={this.props.config}
                location={this.props.location}
                currentFilter={this.state.currentFilter} />
        );
    }
}

SwipeList.propTypes = {
    swipes: PropTypes.arrayOf(PropTypes.object).isRequired,
    config: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    supervisorData: PropTypes.object.isRequired
};

export default withStyles(SwipeList, styles);